import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { AuditLogModule } from 'src/modules/audit-log/module';
import { AuditLogApiService } from 'src/modules/audit-log/services/audit-log-api-service';
import { DirectivesModule } from 'src/modules/directives/module';
import { CategoriesDashboard } from './components/categories/component';
import { CategoriesListView } from './components/categories/list/component';
import { CategoryDelete } from './components/categories/modals/delete/component';
import { DeleteLogDashboard } from './components/delete-log/component';
import { LocalOffersModule } from 'src/modules/local-offers/module';
import { LocalOffersApiService } from 'src/modules/local-offers/services/local-offers-api-service';
import { LocalOffersDashboard } from './components/local-offers/component';
import { HomepageOffersDashboard } from './components/homepage/component';
import { HomepageModule } from 'src/modules/homepage/module';
import { RelatedContentModule } from 'src/modules/related-content/module';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    DirectivesModule,
    AuditLogModule,
    LocalOffersModule,
    RelatedContentModule,
    HomepageModule,
    DragDropModule
  ],
  declarations: [
    LocalOffersDashboard,
    HomepageOffersDashboard,
    DeleteLogDashboard,
    CategoriesDashboard,
    CategoriesListView,
    CategoryDelete,
    HomepageOffersDashboard
  ],
  exports: [
    LocalOffersDashboard,
    HomepageOffersDashboard,
    DeleteLogDashboard,
    CategoriesDashboard,
    CategoriesListView,
    CategoryDelete,
    HomepageOffersDashboard
  ],
  providers: [AuditLogApiService, LocalOffersApiService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AdminModule {}
